





























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LanguageSelector extends Vue {
  isOpen = false;

  options = [
    { value: "it", label: "IT" },
    { value: "en", label: "EN" },
    { value: "cn", label: "中文" },
  ];

  get currentLocale() {
    return this.options.find((locale) => locale.value == this.$i18n.locale);
  }

  set(option: any) {
    this.$i18n.locale = option.value;
    this.isOpen = false;
  }
}
